import React from 'react';
import md5 from 'md5';
import { Icon } from 'rmwc/Icon';

import './account-icon.css';

export default function AccountIcon({ currentUser }) {
  let accountIcon = <Icon icon="account_circle" />;

  if (currentUser) {
    if (currentUser.photoURL && !currentUser.photoURL.match('fbcdn')) {
      accountIcon = <Icon iconOptions={{ strategy: 'url' }} icon={currentUser.photoURL} />;
    } else if (currentUser.email) {
      accountIcon = (
        <Icon
          iconOptions={{ strategy: 'url' }}
          icon={`https://www.gravatar.com/avatar/${md5(currentUser.email)}`}
        />
      );
    }
  }

  return <div className="account-icon">{accountIcon}</div>;
}
